import React, { Component } from 'react'
import { Project, ResourcesById, ProjectStatus } from '../../schema/types.d'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ProjectStatus as ProjectStatusLib } from './period'

interface EmployeeColumnProps {
  name: string
  role: string
  color_class: string
}
class EmployeeColumn extends Component<EmployeeColumnProps> {
  render() {
    return (
      <td className="nowrap lh-copy pa1 ph0-l bb br b--black-10">
        <div className="dt">
          <div className="dtc v-mid">
            <FontAwesomeIcon
              icon="th-large"
              className={'f-' + this.props.color_class}
            />
          </div>
          <div className="dtc pl2">
            <div className="f7 black-70">{this.props.name}</div>
            <div className="f7 black-50">{this.props.role}</div>
          </div>
        </div>
      </td>
    )
  }
}

interface WorkHours {
  planned_labor_hours: number
  planned_labor_cost: number
  budget_labor_hours: number
  budget_labor_cost: number
  regular_hours: number
  overtime_hours: number
  special_overtime_hours: number
}

interface WorkHoursCellProps {
  work_hours: WorkHours
  color_class: string
}

class WorkHoursCell extends Component<WorkHoursCellProps> {
  render() {
    const {
      regular_hours,
      overtime_hours,
      special_overtime_hours,
      planned_labor_hours,
      planned_labor_cost,
      budget_labor_hours,
      budget_labor_cost
    } = this.props.work_hours
    return (
      <td className="bg-animate hide-child pt2 pb2 ph0-l f6 white-40">
        <div
          className={
            budget_labor_hours > 0 ? 'lighten-' + this.props.color_class : ''
          }
        >
          {budget_labor_hours > 0 ? budget_labor_hours.toFixed(1) : null}
        </div>
        <div
          className={
            planned_labor_hours > 0 ? 'lighten2-' + this.props.color_class : ''
          }
        >
          {planned_labor_hours > 0 ? planned_labor_hours.toFixed(1) : null}
        </div>
        <div className={regular_hours > 0 ? this.props.color_class : ''}>
          {regular_hours > 0 ? regular_hours : null}
        </div>

        {regular_hours || planned_labor_hours || budget_labor_hours ? (
          <div className="db absolute bg-white ba br2 b--moon-gray pa2 w4 shadow-5 child">
            <div className="f7 lh-copy near-black ma0">
              <div>Budget - {budget_labor_hours.toFixed(2)}</div>
              <div>Plan - {planned_labor_hours.toFixed(2)}</div>
              <p className="bold">Actual Labor : </p>
              <div> Regular - {regular_hours}</div>
              <div>Overtime - {overtime_hours + special_overtime_hours}</div>
              {/* <div>Special overtime : {special_overtime_hours}</div> */}
              {/* <div>Planned Cost : {planned_labor_cost.toFixed(2)}</div> */}
              {/* <div>Budgeted Cost : {budget_labor_cost.toFixed(2)}</div> */}
            </div>
          </div>
        ) : null}
      </td>
    )
  }
}

interface ColumnHeaderProps {
  text: string
}
class ColumnHeader extends Component<ColumnHeaderProps> {
  render() {
    return (
      <th className="nowrap bb br b--black-10 tl pb3 pr3 bg-white thumbnail_title">
        {this.props.text}
      </th>
    )
  }
}

interface WorkPlannerProps extends ProjectStatus.Props {
  project: Project.Project
}
class WorkPlanner extends Component<WorkPlannerProps> {
  extractEmployees(labor: ProjectStatus.Labor[]): string[] {
    let emp = new Set()
    labor.map(l => emp.add(l.resource.id))
    return [...emp]
  }

  monthYearDisplay(d: Date) {
    if (d) {
      let month = d.getMonth()
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
      const monthName = months[month - 1]
      return monthName ? monthName + ' ' + d.getFullYear() : ''
    } else return ''
  }

  render() {
    return (
      <ProjectStatus.Component
        variables={{ projectId: this.props.project.projectNumber }}
      >
        {({ loading, error, data }) => {
          if (loading) return <div>Fetching</div>
          if (error) return <div>Error</div>
          if (!data) return <div>No data!</div>
          const project = data.project
          const projectStatusLib = new ProjectStatusLib(project, 30)
          const emp_ids = this.extractEmployees(project.labor)

          const l_timelines = projectStatusLib.labor_timeline_by_resources()
          const date_headers = projectStatusLib.dateHeaders()
          let p_timelines = projectStatusLib.plan_timeline_by_resources()
          let b_timelines = projectStatusLib.budget_timeline_by_resources()
          return (
            <ResourcesById.Component variables={{ ids: emp_ids }}>
              {({ loading, error, data }) => {
                if (loading) return <div>Fetching</div>
                if (error) return <div>Error</div>
                if (!data) return <div>No data!</div>
                const resources = data.resources_by_id

                return (
                  <div className="bg-projects fr w-75 pl4 mt1">
                    <h4 className="thumbnail_title">Work Planner</h4>
                    <article className="work-planner b--black-10">
                      <div className="bb b--black-10 pa3">
                        <div className="f6 b black-70 pl2">Project Roadmap</div>
                        <div className="f7 b black-50 pl2 mt2">
                          {this.monthYearDisplay(projectStatusLib.start)} -{' '}
                          {this.monthYearDisplay(projectStatusLib.end)}
                        </div>
                      </div>
                      <div />
                      <div className="relative overflow-auto">
                        <table className="w-100">
                          <thead>
                            <tr>
                              <th className="bb br b--black-10 tl pb3 pr3 bg-white thumbnail_title">
                                {'Total: ' + resources.length}
                              </th>
                              {date_headers.map((dt, index) => (
                                <ColumnHeader key={index} text={dt} />
                              ))}
                            </tr>
                          </thead>

                          {resources.map((r, r_index) => {
                            const l_t = l_timelines.get(r.id)
                            const p_t =
                              p_timelines.get(r.id) ||
                              new Array(l_t.length).fill([0, 0])
                            const b_t =
                              b_timelines.get(r.id) ||
                              new Array(l_t.length).fill([0, 0])
                            return (
                              <tbody>
                                <tr key={r.id} style={{ height: '60px' }}>
                                  <EmployeeColumn
                                    name={r.fullName}
                                    role={r.laborCategory}
                                    color_class={'color-' + (r_index % 19)}
                                  />
                                  {l_t.map((s, p_index) => {
                                    let [rh, oh, soh] =
                                      s.length > 0
                                        ? [s[0], s[1], s[2]]
                                        : [0, 0, 0]
                                    let plan = p_t[p_index]
                                    let budget = b_t[p_index]
                                    let [plh, plc] =
                                      plan.length > 0
                                        ? [plan[0], plan[1]]
                                        : [0, 0]
                                    let [blh, blc] =
                                      budget.length > 0
                                        ? [budget[0], budget[1]]
                                        : [0, 0]
                                    return (
                                      <WorkHoursCell
                                        key={p_index}
                                        work_hours={{
                                          regular_hours: rh,
                                          overtime_hours: oh,
                                          special_overtime_hours: soh,
                                          planned_labor_hours: plh,
                                          planned_labor_cost: plc,
                                          budget_labor_hours: blh,
                                          budget_labor_cost: blc
                                        }}
                                        color_class={'color-' + (r_index % 19)}
                                      />
                                    )
                                  })}
                                </tr>
                              </tbody>
                            )
                          })}
                        </table>
                      </div>
                    </article>
                  </div>
                )
              }}
            </ResourcesById.Component>
          )
        }}
      </ProjectStatus.Component>
    )
  }
}

export default WorkPlanner
